// frontend/src/Redux/Constants/BannerConstants.js
export const BANNER_LIST_REQUEST = "BANNER_LIST_REQUEST";
export const BANNER_LIST_SUCCESS = "BANNER_LIST_SUCCESS";
export const BANNER_LIST_FAIL = "BANNER_LIST_FAIL";
